import { useState } from "react";

export const faqs = [
  {
    q: "How fast can I get a passport in Kenner, LA?",
    a: "Through Fast Passport Center, expedited processing can be as fast as 24 hours depending on your eligibility and the processing option you select. Standard government processing through a post office or acceptance clerk in Kenner can take 2–6 months, especially during busy travel seasons. For MSY airport employees, cruise passengers, and Jefferson Parish families, that timeline is simply not viable.",
  },
  {
    q: "Can MSY airport employees in Kenner get an expedited passport quickly?",
    a: "Absolutely. MSY airline crew members, TSA officers, ground staff, and airport vendors are some of our most common clients in Kenner. International layovers, repositioning flights, and crew scheduling changes happen with little notice. We regularly process expedited renewals and new applications for airport workers on compressed timelines. Contact us as soon as your schedule is confirmed.",
  },
  {
    q: "What if my passport expires before a New Orleans cruise departure?",
    a: "This happens more often than you would think. Cruise passengers departing from the Julia Street or Erato Street terminals in New Orleans often discover expired passports days before sailing. Most Caribbean and Mexican cruise itineraries require your passport to be valid for at least six months beyond your return date. If your expiration is cutting it close, we strongly recommend expedited processing. Standard mail-in renewal through a Kenner post office typically takes 2–6 months.",
  },
  {
    q: "Can families in Metairie and River Ridge get expedited passports?",
    a: "Yes. Families throughout Jefferson Parish have the same access to our expedited services as Kenner residents. Since we operate remotely, your physical location in the parish does not affect processing speed. Ship your documents overnight from anywhere in the Kenner-Metairie area, and we handle the rest. Most clients in Jefferson Parish receive their passports within 2–9 business days.",
  },
  {
    q: "How quickly can travelers in Harahan and Jefferson receive an expedited passport?",
    a: "Harahan, Jefferson, and surrounding communities have the same access to our expedited services as Kenner residents. Since we operate remotely, your physical location in Jefferson Parish does not affect processing speed. Ship your documents overnight, and we handle the rest. Most clients in the Kenner area receive their passports within 2–9 business days.",
  },
  {
    q: "Can petroleum industry workers in Kenner expedite a passport renewal?",
    a: "Yes — petroleum engineers, offshore logistics coordinators, and energy industry professionals from Kenner, Metairie, and throughout Jefferson Parish are well within our service area. Whether you are traveling to West Africa for a rotation, attending an industry conference in the Middle East, or visiting offshore operations in Brazil, we make the renewal process straightforward. You do not need to drive to New Orleans for a passport agency appointment.",
  },
  {
    q: "Do I need to visit an office to use Fast Passport Center?",
    a: "No — most Kenner travelers start online and ship their documents via overnight courier. There is no local Fast Passport Center office in Kenner, but that is the point: you do not need one. Start your order online, follow the checklist, and ship your documents overnight from anywhere in Jefferson Parish.",
  },
  {
    q: "What documents do I need for an expedited passport?",
    a: "Most applicants need: proof of U.S. citizenship (current or expired U.S. passport, birth certificate, or naturalization certificate), a government-issued photo ID, completed passport forms, and passport photos. We provide a personalized checklist after you start your order, so you know exactly what is required for your specific situation.",
  },
  {
    q: "Is Fast Passport Center an official government agency?",
    a: "No — Fast Passport Center is a private, approved and registered U.S. Department of State passport courier service. We are not a government agency. We work within the official passport system to provide expedited processing through reserved courier submission availability.",
  },
];

export default function KennerFAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-white py-20 md:py-28">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Questions?</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Frequently Asked <span className="text-[#F6C344]">Questions</span>
          </h2>
          <p className="text-gray-500 text-base">
            Everything Kenner and Jefferson Parish travelers ask us most often about expedited passport services.
          </p>
        </div>

        <div className="space-y-2">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] rounded-lg border border-gray-200 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between gap-4 p-5 text-left cursor-pointer"
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
              >
                <span className="font-semibold text-[#1A365D] text-sm leading-snug">{faq.q}</span>
                <div className="w-7 h-7 flex items-center justify-center rounded-full bg-[#1A365D] flex-shrink-0">
                  <i
                    className={`text-white text-sm transition-transform duration-200 ${
                      openIndex === i ? "ri-subtract-line" : "ri-add-line"
                    }`}
                  ></i>
                </div>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-5">
                  <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-200 pt-4">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-gray-500 text-sm mb-4">Still have questions? Our team is here to help.</p>
          <a
            href="tel:8772530084"
            className="inline-flex items-center gap-2 bg-[#1A365D] hover:bg-[#0F2240] text-white font-semibold text-sm px-6 py-3 rounded-md transition-all whitespace-nowrap"
          >
            <i className="ri-phone-line"></i> Call 877-253-0084
          </a>
        </div>
      </div>
    </section>
  );
}